import React, { useEffect, useState, useRef } from 'react';
import NumberFormat from 'react-number-format';
import { calculateAssessedValue } from '../../../../../helpers/utils/OrderDetailUtils';

interface Props {
    setCertificate: any;
    certificate: any;
    showAccount: number;
    name: string;
    setName: any;
    setProductTypeInvisible: any;
    editable: boolean;
    setIsSavedResult: any;
    setRender?: any;
}

const AssessmentsRowFormatting: React.FC<Props> = ({
                                                       setCertificate,
                                                       certificate,
                                                       showAccount,
                                                       name,
                                                       setName,
                                                       setProductTypeInvisible,
                                                       editable,
                                                       setIsSavedResult,
                                                       setRender = null,
                                                   }) => {
    const curAccount = certificate.accounts?.[showAccount];
    const fieldValue = curAccount?.assessment?.[name];

    const [inputValue, setInputValue] = useState<string>(
        fieldValue !== undefined && fieldValue !== null ? fieldValue.toString() : ''
    );

    // Sync input value if external changes occur
    useEffect(() => {
        const newVal = curAccount?.assessment?.[name];
        const newValString = newVal !== undefined && newVal !== null ? newVal.toString() : '';
        if (newValString !== inputValue) {
            setInputValue(newValString);
        }
    }, [curAccount?.assessment?.[name]]);

    useEffect(() => {
        if (!editable) return;

        const floatValue = parseFloat(inputValue.replace(/[$,]/g, ''));
        const cleaned = isNaN(floatValue) ? null : floatValue;

        setCertificate((prev: any) => {
            const updatedAccounts = prev.accounts.map((acc: any, idx: number) => {
                if (idx !== showAccount) return acc;

                return {
                    ...acc,
                    assessment: {
                        ...acc.assessment,
                        [name]: cleaned,
                    },
                    taxDataSource: 'EDITOR',
                    asOfDate: new Date(),
                };
            });

            return {
                ...prev,
                accounts: updatedAccounts,
            };
        });

        if (name === 'homesteadCapValue') {
            const updatedAssessment = {
                ...certificate.accounts[showAccount].assessment,
                [name]: cleaned,
            };
            calculateAssessedValue(showAccount, updatedAssessment, setRender, setCertificate);
        }

        setName(name);
        setProductTypeInvisible(inputValue + new Date().getTime());
    }, [inputValue]);


    return (
        <NumberFormat
            className={`form-control ${!editable ? "border border-text-0 bg-surface-5 text-surface-3" : ""}`}
            placeholder={inputValue === '' ? 'N/A' : '...'}
            value={inputValue}
            prefix={inputValue !== '' ? '$' : ''}
            thousandSeparator
            isNumericString
            onValueChange={(values) => {
                setInputValue(values.value);
                setIsSavedResult(false);
            }}
            readOnly={!editable}
            id={name}
        />
    );
};

export default React.memo(AssessmentsRowFormatting);
